module.exports = __webpack_public_path__ + "img/about-hero.b632f5ba.jpg";